export const divideCurrencyFields = {
	budget: 1000000,
	bid:    1000000,
	spend:  1000000,
	cpc:    1000000,
	ecpm:   1000000,
};

export const DEFAULT_VIDEO_THUMBNAIL = '../assets/images/video-placeholder.png';

export const URL_REGEX = /http(s)?:\/\/[\w-]+\.[\w-]+.*/;
export const mobileStoreRegex = /(apps\.apple\.com\/|play\.google\.com\/)/;
export const appleStoreRegex = /apps\.apple\.com\//;
